/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface GetEnergyDebug$Params {
  location_id: string;
  aggregation?: string;
  at?: string;
}

export function getEnergyDebug(http: HttpClient, rootUrl: string, params: GetEnergyDebug$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
  const rb = new RequestBuilder(rootUrl, getEnergyDebug.PATH, 'get');
  if (params) {
    rb.path('location_id', params.location_id, {});
    rb.query('aggregation', params.aggregation, {});
    rb.query('at', params.at, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<any>;
    })
  );
}

getEnergyDebug.PATH = '/locations/{location_id}/energy-debug';
